export default __webpack_public_path__ + "static/media/podpora.2172c164.webp";